import { StrictMode, useEffect } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { createClient } from '@supabase/supabase-js'

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
)

// Handle auth state changes and email confirmation redirects
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth event:', event, session)
  
  if (event === 'SIGNED_IN' && session) {
    // Check if this is from email confirmation
    const pendingProfileStr = localStorage.getItem('pendingProfile')
    
    if (pendingProfileStr) {
      console.log('Email confirmed, user signed in with pending profile')
      // Redirect to account page where profile will be created
      window.location.href = '/account'
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
